<template>
    <div class="hidden py-4 md:block">
        <ul
            class="flex items-end justify-center gap-1 border-t border-gray-325"
        >
            <li
                @click="goToPage(currentPage - 1)"
                :class="
                    'ml-4 mr-auto rounded border px-2 py-1 text-center text-[15px] font-medium leading-none text-gray-625 ' +
                    ' ' +
                    (currentPage <= 1
                        ? 'opacity-50 hover:cursor-not-allowed'
                        : 'hover:cursor-pointer hover:bg-primary-525 hover:text-white')
                "
            >
                Previous
            </li>
            <li
                v-for="n in paginationRange"
                @click="goToPage(n)"
                :class="
                    'min-w-[32px] border-t-[3px] pt-4 text-center text-[15px] font-medium leading-none text-gray-625 hover:cursor-pointer' +
                    ' ' +
                    (currentPage === n
                        ? 'border-primary-525 text-primary-525'
                        : 'border-transparent')
                "
            >
                <div class="">
                    {{ n }}
                </div>
            </li>
            <li
                @click="goToPage(currentPage + 1)"
                :class="
                    'ml-auto mr-4 rounded border px-2 py-1 text-center text-[15px] font-medium leading-none text-gray-625 ' +
                    ' ' +
                    (currentPage >= lastPage
                        ? 'opacity-50 hover:cursor-not-allowed'
                        : 'hover:cursor-pointer hover:bg-primary-525 hover:text-white')
                "
            >
                Next
            </li>
        </ul>
    </div>
    <div
        class="py-4 text-center text-primary-525 underline md:hidden"
        @click="scrollToTop"
    >
        Back to Top
    </div>
</template>
<script>
export default {
    name: "ModelPaginator",
    emits: ["models-fetched"],
    props: {
        endpoint: {
            type: String,
            default: "",
        },
        limit: {
            type: Number,
            default: 10,
        },
        params: {
            type: Array,
            default: [],
        },
        infiniteScrollOnMobile: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            currentPage: 1,
            lastPage: 1,
            results: 0,
            items: [],
            totalResults: 0,
            isMobileView: false,
        };
    },
    methods: {
        callFetchModelsDebounced: _.debounce(function (goToPage) {
            this.fetchModels(goToPage);
        }, 100),
        fetchModels(page) {
            let vm = this;

            axios
                .get(vm.endpoint, {
                    params: {
                        page: page,
                        params: vm.params,
                        limit: vm.limit,
                    },
                })
                .then(function (response) {
                    vm.currentPage = response.data.current_page;
                    vm.lastPage = response.data.last_page;
                    vm.results = response.data.data.length;
                    vm.totalResults = response.data.total;

                    if (vm.isMobileView && vm.infiniteScrollOnMobile) {
                        vm.items = [...vm.items, ...response.data.data];
                    } else {
                        vm.items = response.data.data;
                    }

                    vm.$emit("models-fetched", {
                        currentPage: vm.currentPage,
                        lastPage: vm.lastPage,
                        results: vm.results,
                        totalResults: vm.totalResults,
                        items: vm.items,
                    });
                });
        },
        goToPage(targetPage) {
            let page = targetPage;

            if (targetPage <= 0) {
                page = 1;
            }

            if (targetPage > this.lastPage) {
                page = this.lastPage;
            }

            this.fetchModels(page);
        },
        handleScroll() {
            let vm = this;
            if (
                window.innerHeight + window.pageYOffset >=
                document.body.offsetHeight - 100 &&
                vm.isMobileView
            ) {
                if (vm.infiniteScrollOnMobile && vm.currentPage < vm.lastPage) {
                    vm.callFetchModelsDebounced(vm.currentPage + 1);
                }
            }
        },
        handleResize() {
            let vm = this;

            vm.isMobileView = window.innerWidth <= 768;

            if (vm.isMobileView) {
                vm.callFetchModelsDebounced(vm.currentPage);
            }

        },
        scrollToTop() {
            window.scrollTo(0, 0);
        },
    },
    mounted() {
        this.fetchModels();
        this.isMobileView = window.innerWidth <= 768;

        window.addEventListener("scroll", this.handleScroll);
        window.addEventListener("resize", this.handleResize);
    },
    unmounted() {
        window.removeEventListener("scroll", this.handleScroll);
        window.removeEventListener("resize", this.handleResize);
    },
    computed: {
        paginationRange() {
            let paginationRange = [];

            for (let i = 1; i <= this.lastPage; i++) {
                paginationRange.push(i);
            }

            return paginationRange;
        },
    },
    watch: {
        params: {
            handler(newValue, oldValue) {
                console.log(newValue);
                console.log(oldValue);

                if (!_.isEqual(newValue, oldValue)) {
                    this.data = [];
                    this.fetchModels(1);
                }
            },
            deep: false,
        },
    },
};
</script>
